import { ErrorCode, errorCodeMessage } from "./ErrorCode";

/**
 *
 * 错误解析
 * @export
 * @param {string} errorMsg 错误信息
 * @param {*} data 错误返回的数据
 * @returns
 */
export function ErrorMessage(errorMsg: string, data: any) {
  const errorCode = getErrorCode(errorMsg) || ErrorCode.SYSTEM_BUSY;
  const errorLocaleKey = getErrorLocaleKey(errorCode);
  const error = {
    data,
    code: errorCode,
    localeKey: errorLocaleKey || errorCodeMessage[ErrorCode.SYSTEM_BUSY]
  };
  return error;
}

export function getErrorCode(codeMsg: string | number = "") {
  let errorMsg = codeMsg + "";
  let start = errorMsg.indexOf("[");
  // 兼容处理，errorMsg可能直接为code，可能在[]中
  if (start <= -1) {
    errorMsg = `[${errorMsg}]`;
    start = 0;
  }
  const end = errorMsg.indexOf("]");
  return errorMsg.substring(start + 1, end);
}

function getErrorLocaleKey(errorCode: string) {
  return errorCodeMessage[errorCode] || errorCodeMessage[ErrorCode.SYSTEM_BUSY];
}
